/* Repaint the free-delivery bar after a FULL drawer re-render (Jamie, 2026-09-06).

   🔴 THE BUG. Adding a combo left two hairlines with an empty band between them at the top of the
   drawer, where "FREE delivery unlocked" should be.

   Why: snippets/free-shipping-bar.liquid renders an EMPTY shell, `<div data-pvs-freeship
   class="pvs-fs is-empty">`, and free-shipping-bar.js fills it. That script repaints on five
   events (on:cart:add, on:line-item:change, dispatch:cart-drawer:refresh, cart:updated,
   cart:refresh) — and cart-drawer.js's renderContents(), which replaces the drawer's ENTIRE
   innerHTML, dispatches none of them. So the freshly server-rendered empty shell just stays empty.

   That path is the normal one for the combo pages: they do not pass the drawer's section in their
   add-to-cart, so the drawer opens stale, refreshIfStale() fires, and the whole drawer is
   re-rendered. ⛔ Do not "fix" this by moving the bar out of the drawer; it belongs there.

   free-shipping-bar.js exposes window.__pvsFreeShip.refresh() for exactly this. */
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var pending = false;

  function heal() {
    pending = false;
    var bar = drawer.querySelector('[data-pvs-freeship]');
    if (!bar) return;
    // Only act on the empty shell. Once it has content this is a no-op, so the observer
    // cannot drive itself in a loop.
    if (bar.innerHTML.trim()) return;
    if (window.__pvsFreeShip && typeof window.__pvsFreeShip.refresh === 'function') {
      window.__pvsFreeShip.refresh();
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(heal, 40);
  }

  // childList/subtree catches renderContents(); the `open` attribute catches the drawer being
  // opened after a refresh that landed while it was closed.
  new MutationObserver(schedule).observe(drawer, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
}());
